export interface IAvailableSlot {
  instructorId: number;
  from: string;
  to: string;
  //gearType?: GearType | GearTypeMc;
  serviceId?: number;
  locationId?: number;
}

export interface IApiResponse<TData> {
  errorCode: number;
  data: TData;
}
export interface IAPIAvailableSlot {
  // FIXME Name
  start: string;
  end: string;
  qty: number;
  seats: number;
}

export enum ServiceKey {
  Default = "default",
  Intro = "intro",
  Risk1 = "risk1",
  Risk2 = "risk2",
}
export enum VehicleType {
  Car = "car",
  Mc = "mc",
  Moped = "moped",
}

export enum BrandField {
  MDA = "mda",
  MTS = "mts",
}
export interface IList<T> {
  total: number;
  result: T[];
}

export interface IRegion {
  id: number;
  name: {
    en: string;
    sw: string;
  };
  sourceKey: string;
  isAvailable: boolean;
  locations: ILocation[];
  services?: IService[];
  isVisible: boolean;
}

export interface IAvailableSlot {
  start: string;
  end: string;
  qty: number;
}

export interface IClassSlot {
  start: Date;
  end: Date;
  serviceId: number;
  slotsLeft: number;
  name: string;
  price: number;
  location: string;
  locationId: number;
  vehicleType: string;
  regionId: number;
}
export interface ILocation {
  id: number;
  name: {
    en: string;
    sw: string;
  };
  address: string;
  regionId: number;
  city: string;
  zip: string;
  lat: string;
  lng: string;
  addressHints?: string | null;
  isActive: boolean;
  isVisible: boolean;
  listOrder: number;
  image: string | null;
  options: {
    brand: BrandField;
  };
}
export interface IService {
  id: number;
  name: ITranslatedField;
  type: ServiceKey;
  vehicleType: any;
  key: string;
  description: any;
  isActive: boolean;
  isVisible: boolean;
  price?: number;
  priceWithVat: number;
  duration: number;
  maxStudentsQty: number;
  domId: string;
  ownLocations: ILocation[];
  associationsIds?: {
    regions?: number[];
    ownLocations?: number[];
    locations?: number[];
    instructors?: number[];
  };
  locations?: any[];
  regions?: IRegion[];
  instructors?: any[];
  packageLessonsQty: number | null;
  inRegionsSortingIndexes: {
    [key: string]: number;
  };
  isExchangeable?: boolean;
  exchangeableLocationsToServicesMapping?: {
    [key: number]: number[];
  };
  languageCode: any;
}

export enum LanguageKeys {
  English = "en",
  Swedish = "sv",
}

export interface ITranslatedField {
  en: string;
  sw: string;
}
export enum BundleContentItemType {
  Service = "Service",
  Theory = "Theory",
}
export interface IBundleContentItem {
  id: number;
  type: BundleContentItemType;
  qty: number;
  discount?: number;
  isPromocodeDiscountable?: boolean;
  price: number;
  priceWithVat: number;
  name?: ITranslatedField;
}

export interface IBundle {
  id: number;
  name: ITranslatedField;
  description: ITranslatedField;
  isActive: boolean;
  regionId?: number;
  price: number;
  priceWithVat: number;
  content: IBundleContentItem[];
  inRegionsSortingIndexes: { [k: number]: number };
  productType?: ProductType;
  vehicleType?: VehicleType;
  languageCode?: LanguageKeys;
}

export enum ProductType {
  Bundle = "Bundle",
  Service = "Service",
}

export enum BinaryAsBooleanValues {
  True = "1",
  False = "0",
}
